import { useEffect, useState } from "react"
import axiosInstance from "../utils/axiosInstance"

export const usePagination = (route, perPage = undefined, autoFetch = true) => {

    const [pagination, setPagination] = useState({
        data: [],
        total: 0,
        per_page: 0,
        current_page: 0,
        from: 0,
        to: 0
    })
    const [loading, setLoading] = useState(false)
    const [filters, setFilters] = useState({
        page: 1,
        per_page: perPage ?? 10,
    })
    const [extraData, setExtraData] = useState()

    function buildParams() {
        const params = {}

        Object.keys(filters).forEach(key => {
            if (filters[key]) {
                params[key] = filters[key]
            }
        })

        return params
    }

    async function fetchData() {
        setLoading(true)
        try {
            const response = await axiosInstance.get(route, {
                params: buildParams()
            })
            setPagination({...pagination, ...response.data.data})
            
            // Store any extra data excluding 'data' property
            const { data, message, ...rest } = response.data
            setExtraData(rest)
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (autoFetch) {
            fetchData()
        }
    }, [filters])
    
    return {
        pagination,
        setPagination,
        loading,
        fetchData,
        filters,
        setFilters,
        extraData
    }
} 